import LoggedInUser from './LoggedInUser'
import Helpers from './Helpers';

export function conversations(limit, offset) {
    return fetch(Helpers.endpoint("/admin_conversations"), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            auth_token: LoggedInUser.getInfo().auth_token
        })
    }).then((response) => response.json())
}

export function conversation(conversation_id, limit, offset) {
    return fetch(Helpers.endpoint("/admin_conversation"), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            conversation_id: conversation_id,
            auth_token: LoggedInUser.getInfo().auth_token
        })
    }).then((response) => response.json())
}

